import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomPaginatorComponent } from 'app/account/digital-wallet/components/custom-paginator/custom-paginator.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
    ],
    declarations: [
        CustomPaginatorComponent,
    ],
    exports: [
        CustomPaginatorComponent,
    ]
})
   
export class CustomPaginatorModule {
}
